export const APP_NAME = "CAP Travel Assistance"
export const PERSIST_STORE_NAME = "user"
export const REDIRECT_URL_KEY = "redirectUrl"
